export default "__VITE_ASSET__vO0y7shL__"